module.exports = __webpack_public_path__ + "img/bb_g1_t_nose-01.c11a1906.svg";